import React from 'react';
import { motion } from 'framer-motion';
import MetricCard from './MetricCard';
import Chart from './Chart';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp, FiUsers, FiRefreshCw, FiDollarSign } = FiIcons;

const PredictiveAnalytics = () => {
  const metrics = [
    {
      title: 'Predicted Visits',
      value: '125K',
      change: '15',
      changeType: 'positive',
      icon: FiUsers,
      color: 'primary',
      subtitle: 'vs. last month'
    },
    {
      title: 'Est. Conversions',
      value: '3.2K',
      change: '7',
      changeType: 'positive',
      icon: FiTrendingUp,
      color: 'success',
      subtitle: 'vs. last month'
    },
    {
      title: 'Bounce Rate',
      value: '42%',
      change: '3',
      changeType: 'positive',
      icon: FiRefreshCw,
      color: 'warning',
      subtitle: 'vs. last month'
    },
    {
      title: 'Est. Revenue',
      value: '$550K',
      change: '12',
      changeType: 'positive',
      icon: FiDollarSign,
      color: 'secondary',
      subtitle: 'Monthly projection'
    }
  ];

  const forecastData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    series: [
      {
        name: 'Actual Revenue',
        type: 'line',
        data: [420000, 450000, 480000, 510000, 525000, 550000],
        smooth: true,
        lineStyle: { color: '#0ea5e9' },
        areaStyle: { color: 'rgba(14,165,233,0.1)' }
      },
      {
        name: 'Predicted Revenue',
        type: 'line',
        data: [550000, 578000, 595000, 615000, 640000, 672000],
        smooth: true,
        lineStyle: { color: '#22c55e', type: 'dashed' },
        areaStyle: { color: 'rgba(34,197,94,0.1)' }
      }
    ]
  };

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-bold text-secondary-900">Predictive Analytics</h2>
          <p className="text-secondary-600">AI-powered forecasts and trends</p>
        </div>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors font-medium"
        >
          View Forecast Details
        </motion.button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {metrics.map((metric, index) => (
          <MetricCard key={index} {...metric} />
        ))}
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-secondary-200 p-6">
        <h3 className="text-lg font-semibold text-secondary-900 mb-4">Revenue Forecast</h3>
        <Chart
          title=""
          data={forecastData}
          type="line"
          height={300}
          options={{
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: (value) => `$${value/1000}K`
              }
            },
            tooltip: {
              trigger: 'axis',
              formatter: (params) => {
                const date = params[0].name;
                const actual = params[0].value.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                });
                const predicted = params[1].value.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                });
                return `${date}<br/> Actual: ${actual}<br/> Predicted: ${predicted}`;
              }
            }
          }}
        />
        <div className="mt-4 flex items-center justify-between text-sm text-secondary-600">
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-primary-500 rounded-full"></div>
              <span>Actual</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-success-500 rounded-full"></div>
              <span>Predicted</span>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <span className="text-xs px-2 py-1 bg-success-50 text-success-700 rounded-full">
              22% Growth Predicted
            </span>
            <span className="text-xs px-2 py-1 bg-primary-50 text-primary-700 rounded-full">
              95% Confidence
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PredictiveAnalytics;